import Vue from 'vue';
import store from 'store';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { isTablet, decode } from 'utils/general';
import { listProductsEventData } from 'lib/tracking';
import datalayer from 'lib/datalayer';
import { A11y, Keyboard, Pagination } from 'swiper/modules';

export default (el) =>
  new Vue({
    el,
    store,
    components: {
      'product-card': () => import('../product-card/product-card.vue'),
      'vimeo-video': () => import('./vimeo-video.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    },
    data: () => ({
      isTablet: isTablet(),
      showProducts: !isTablet(),
      animate: false,
      slideOut: false,
      isTracked: false,
      parentTitle: '',
      listType: 'shop-the-look',
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 10,
        a11y: {
          enabled: true,
          slideLabelMessage: 'Slide {{index}} of {{slidesLength}}'
        },
        watchSlidesProgress: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return `<button aria-label="Go to slide ${index}" class="${className}"></button>`;
          },
        },
        keyboard: true,
        breakpoints: {
          640: {
            slidesPerView: 3,
          },
          1023: {
            spaceBetween: 13,
            slidesPerView: 1.5,
          },
        },
        modules: [A11y, Keyboard, Pagination],
        on: {
          update: function() {
            let maxHeight = 0;
            let slides = document.querySelectorAll('.shop-the-look__products .swiper-slide');
            slides.forEach(slide => {
              maxHeight = Math.max(maxHeight, slide.clientHeight);
            });
            slides.forEach(slide => {
              slide.style.height = maxHeight + 'px';
            });
          },
        }
      },
    }),
    beforeMount() {
      this.parentTitle = this.$el.dataset.heading;
    },

    computed: {
      productsDecoded() {
        const productsData =  JSON.parse(decode(this.$el.dataset.products));
        return productsData.map((p, index) => ({...p, index: index}));
      },
    },
    mounted() {
      setTimeout(() => {
        this.onResize();
        on(window, 'resize', debounce(this.onResize, 300));
      }, 1000);
    },
    created() {
      this.swiperOptions.on = {
        init: (swiper) => this.updateSlidesA11y(swiper),
        transitionEnd: (swiper) => this.updateSlidesA11y(swiper)
      };
    },
    methods: {
      handleButtonClick() {
        if (this.isTablet) {
          this.showProducts = !this.showProducts;
          const { carousel } = this.$refs;
          this.$nextTick(() => {
            if (carousel) {
              carousel.$swiper?.update();
              setTimeout(() => {
                this.updateSlidesA11y(carousel.$swiper)
              }, 0);
            }
          });
        }
        if (!this.isTablet) {
          this.slideOut = !this.slideOut;
        }

        if(this.showProducts && !this.isTracked) {
          this.isTracked = true;
          this.trackView();
        }
      },
      handleHover() {
        if (!this.slideOut && !this.isTablet) {
          this.animate = true;
          setTimeout(() => {
            this.animate = false;
          }, 1000);
        }
      },
      onResize() {
        this.isTablet = isTablet();
        this.slideOut = false;
      },
      async trackView() {
        const extraData = {
          listName: this.parentTitle || undefined,
          listId: this.listType || undefined,
          origin: document.body.dataset.origin,
          originProduct: document.body.dataset.originProduct
        };

        const { products, hasBundleBuilder } = await listProductsEventData(
          this.productsDecoded,
          extraData,
        );

        // track visible elements on page load
        let eventData = {
          ecommerce: {
            item_list_id: this.listType || undefined,
            item_list_name: this.parentTitle || undefined,
            section: 'shop the look section',
            items: products,
          },
        };
        if (hasBundleBuilder) {
          eventData = {
            ...eventData,
            site_section: window.__GLOBAL__.siteSection,
            component_name: this.listType || undefined,
            bundle_type: 'bundle builder'
          }
        }
        datalayer.dataLayerPush('view_item_list', eventData);
      },
      updateSlidesA11y(swiper) {
        const multiView = swiper.params.slidesPerView !== 1 && swiper.params.slidesPerView !== 'auto';

        swiper.slides.forEach((slide, i) => {
          const isVisible = multiView
            ? slide.classList.contains('swiper-slide-visible')
            : i === swiper.activeIndex;
          console.log(slide.className, slide)
          slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
          const focusElements = slide.querySelectorAll('a,button,input,select,textarea');
          focusElements.forEach(el => {
            if (isVisible) {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', '-1');
            }
          });
        });
      }
    },
  });
